import { UiQueries } from './UiQueries';

export function hasUnsavedChangesQuery(this: UiQueries): boolean {
  // Traverse all weeks etc to find if there is any user data.
  // This could be an expensive call. If it needs to be invoked often,
  // maybe have changing user data set a global "hasChanged" flag
  // and just return "hasChanged";
  // Alternatively, userdata could be moved to the root level and just
  // check if that one array is empty or not.
  const hasUserData = this.uiState.weeks.some((week) =>
    week.workCenterWeeks.some((workCenterWeek) =>
      this.hasUnsavedChangesForWorkCenterWeek(workCenterWeek)
    )
  );

  return hasUserData;
}
